import React, { useEffect, useState } from "react";
import styled from "styled-components";
import GlobalMenu from "../components/globalmenu";
import SakokuProject from "../components/SakokuProject";
import Research from "../components/Research";
import Events from "../components/Events";
import About from "../components/About";
import Boot from "../components/boot";
import { Helmet } from "react-helmet";
import { PanelProvider } from "../components/panel";
import bg from "../images/bg.png";
import ogImage from "../images/og.png";
import Alert from "../components/alert";

const Main = styled.main`
  > div {
    float: right;
  }

  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  background: ${Math.random() < 0.5 ? "url(" + bg + ")" : "none"};
`;

const Container = styled.div`
  width: 200px;
  display: flex;
  flex-wrap: wrap;
`;

const IndexPage = () => {
  const [loading, setLoading] = useState(true);
  const [focus, setFocus] = useState("");
  const [lang, setLang] = useState(1); // 0:en, 1:ja

  const [topState, setTopState] = useState(true);
  const [aboutUsState, setAboutUsState] = useState(false);
  const [aboutProjectState, setAboutProjectState] = useState(false);
  const [referenceState, setReferenceState] = useState(false);
  const [eventsState, setEventsState] = useState(false);
  const [researchState, setResearchState] = useState(false);

  const switchLang = (value) => {
    setLang(value);
  };

  const finished = () => {
    const randColor = Math.random() < 0.5 ? "#7ca9dd" : "#e5e5e5";
    document.body.style.backgroundColor = randColor;
    setLoading(false);
  };

  const manageSelection = (target) => {
    setFocus(target);
  };

  const manageWindow = (target, value) => {
    if (target === "Top") {
      setTopState(value);
    }

    if (target === "About") {
      setAboutUsState(true);
      setAboutProjectState(true);
      setReferenceState(true);
    }

    if (target === "About Us") {
      setAboutUsState(value);
    }

    if (target === "About Project") {
      setAboutProjectState(value);
    }

    if (target === "Reference") {
      setReferenceState(value);
    }

    if (target === "Research") {
      setResearchState(value);
    }

    if (target === "Events") {
      setEventsState(value);
    }
  };

  useEffect(() => {
    let lang = navigator.languages[0] === "ja" ? 1 : 0;
    setLang(lang);
    document.body.addEventListener("click", function () {
      manageSelection("");
    });
  }, []);

  return (
    <>
      <Helmet
        title="鎖国 ［Walled Garden］プロジェクト"
        meta={[
          { property: "og:url", content: "https://special.ycam.jp/sakoku/" },
          { property: "og:type", content: "website" },
          {
            property: "og:title",
            content: "鎖国 ［Walled Garden］プロジェクト",
          },
          { property: "og:locale", content: "ja_JP" },
          { property: "og:locale:alternate", content: "en_US" },
          {
            property: "og:description",
            content:
              "「鎖国［Walled Garden］プロジェクト」は、情報とインターネットの未来をテーマに、YCAMの研究開発チーム 「YCAMInterLab」がアーティストやジャーナリストなどと積極的なコラボレーションしながら、リサーチを通したワークショップ開発、またワークショップのテーマをベースにした作品製作と、年度ごとに連続したアウトプットをおこないながら長期的に取り組むプロジェクトです。",
          },
          {
            property: "og:image",
            content: "https://special.ycam.jp" + ogImage,
          },
          { name: "twitter:card", content: "summary_large_image" },
          {
            property: "description",
            content:
              "「鎖国［Walled Garden］プロジェクト」は、情報とインターネットの未来をテーマに、YCAMの研究開発チーム 「YCAMInterLab」がアーティストやジャーナリストなどと積極的なコラボレーションしながら、リサーチを通したワークショップ開発、またワークショップのテーマをベースにした作品製作と、年度ごとに連続したアウトプットをおこないながら長期的に取り組むプロジェクトです。",
          },
          {
            property: "keywords",
            content:
              "山口情報芸術センター,Yamaguchi Center for Arts and Media,YCAM,ワイカム,鎖国,sakoku,walled garden,Kyle McDonald,カイル・マクドナルド",
          },
        ]}
      >
        <link rel="stylesheet" href="https://use.typekit.net/dns8ydn.css" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      {loading ? (
        <Boot finished={finished} />
      ) : (
        <>
          <GlobalMenu
            switchLang={switchLang}
            lang={lang}
            manageWindow={manageWindow}
          />
          <Main>
            <PanelProvider>
              <Container>
                <Alert lang={lang} />
                <SakokuProject
                  isOpen={topState}
                  lang={lang}
                  manageWindow={manageWindow}
                  manageSelection={manageSelection}
                  selected={focus}
                />
                <About
                  isAboutUsOpen={aboutUsState}
                  isAboutProjectOpen={aboutProjectState}
                  isReferenceOpen={referenceState}
                  lang={lang}
                  manageWindow={manageWindow}
                  manageSelection={manageSelection}
                  selected={focus}
                />
                <Research
                  isOpen={researchState}
                  lang={lang}
                  manageWindow={manageWindow}
                  manageSelection={manageSelection}
                  selected={focus}
                />
                <Events
                  isOpen={eventsState}
                  lang={lang}
                  manageWindow={manageWindow}
                  manageSelection={manageSelection}
                  selected={focus}
                />
              </Container>
            </PanelProvider>
          </Main>
          <div id="panel-wrapper" />
        </>
      )}
    </>
  );
};

export default IndexPage;
